import React from 'react';
import hooks from './hooks';
import View from './view';

export default function(props) {
    return <View {...props} hooks={hooks} />;
}
